import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { makeStyles, Divider } from '@material-ui/core';
import { appProfileSelector } from 'redux/selectors';
import { ApplicationContent, Header } from './components';
import { setLoading } from 'redux/actions/app';
import { useSelector, useDispatch } from 'react-redux';
import * as API from 'services/api';
import { groupBy, includesSearchWord } from 'utils';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Searchbar from './searchbar'
import PropTypes from 'prop-types';

const HIDDEN_GROUP = new Set(["ESPACE CLIENT"])
const all_button = 'all'

const useStyles = makeStyles(theme => ({
  container: {
    padding: `${theme.spacing(5)}px ${theme.spacing(5)}px`,
    /* keep page scrollable but hide native vertical scrollbar visuals */
    overflowY: 'auto',
    msOverflowStyle: 'none', /* IE and Edge */
    scrollbarWidth: 'none', /* Firefox */
    '&::-webkit-scrollbar': {
      width: 0,
      background: 'transparent'
    },
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
    },
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
    }
  },
  mainContent: { marginTop: theme.spacing(3), minHeight: '100vh' },
  togglebtngroup: {
    /* center the group horizontally and use a 5px bottom gap as requested */
    display: 'flex',
    // justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
    flexWrap: 'wrap', /* allow buttons to drop to next line when not enough space */
    marginBottom: 5,
    marginRight: 'auto',
    marginLeft: 'auto',
    '& > *': {
      marginBottom: theme.spacing(1),
    }
  },
  togglebtn: {
    border: '1px solid #030F40 !important',
    borderRadius: '30px !important',
    marginRight: theme.spacing(2),
    padding: '10px 30px',
    color: `${theme.palette.app.primary} !important`
    ,
  },
  selectedBtn: {
    fontWeight: 'bold !important',
    color: `white !important`,
    backgroundColor: `${theme.palette.app.primary} !important`
  },
  btnLabel: {
    fontSize: '12px !important'
  },
}));

const Applications = ({ intl: { formatMessage }, disablePadding, hideBookmark, title, hideSubtitle, searchPlaceholder }) => {
  const classes = useStyles();
  const profile = useSelector(appProfileSelector);
  const dispatch = useDispatch();
  const [apaves, setApaves] = useState([]);
  const [bookmarks, setBookmarks] = useState([]);
  const [formats, setFormats] = useState(all_button);
  const [datasource, setDatasource] = useState([]);
  const [keyword, setKeyword] = useState('')

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
    window.dataLayer.push({
      'event': 'navigation',
      'navigation_template': 'Applications',
      'navigation_path': window.location.href,
      'click_name': newFormats == 'all' ? formatMessage({ id: "profile.service.all" }) : newFormats
    });
  };

  useEffect(() => {
    dispatch(setLoading(true));
    let new_bookmarks = localStorage.getItem('bookmarks')
    try {
      new_bookmarks = JSON.parse(new_bookmarks)
    } catch (error) {
      console.log(error)
      new_bookmarks = []
    }
    setBookmarks(new_bookmarks || []);
    API.listApaveApps()
      .then(res => {
        dispatch(setLoading(false));
        const data = res.data ? res.data.filter(apave => !HIDDEN_GROUP.has(apave.group)) : []
        setApaves(data);
        setDatasource(data);
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  }, []);

  useEffect(() => {
    if (apaves.length > 0) {
      setDatasource([])
      setTimeout(() => {
        setDatasource(apaves.filter(item => formats == all_button || formats == item.group))
      }, 100);
    }
  }, [formats])

  const onBookMark = (id) => () => {
    let new_bookmarks = []
    if (bookmarks.includes(id)) {
      new_bookmarks = bookmarks.filter(item => item != id)
    } else {
      window.dataLayer.push({
        'event': 'add_to_wishlist'
      });
      new_bookmarks = [...bookmarks, id]
    }
    setBookmarks(new_bookmarks)
    localStorage.setItem('bookmarks', JSON.stringify(new_bookmarks));
  }


  const grouped_apaves = groupBy(apaves, 'group')
  const permissions = profile.services || [];
  let enabled_apaves = []
  let disabled_apaves = []

  let filtered = datasource
  if (keyword && keyword.length > 0) filtered = filtered.filter(item => includesSearchWord(item.title, keyword))

  filtered.map(item => {
    if (!!permissions.find(permission => permission.allowed && permission.appId == item.appId)) {
      enabled_apaves.push(item)
    } else disabled_apaves.push(item)
  })

  const bookmarked_apaves = bookmarks.map(item => filtered.find(apave => apave.id == item)).filter(item => !!item)
  const groups = [all_button, ...Object.keys(grouped_apaves)]


  return (
    <div className={classes.container} style={disablePadding ? { padding: 0 } : {}}>
      <Searchbar
        keyword={keyword}
        setKeyword={setKeyword}
        title={title}
        hideSubtitle={hideSubtitle}
        searchPlaceholder={searchPlaceholder}
      />
      {
        groups.length > 1 &&
        <ToggleButtonGroup value={formats} onChange={handleFormat} aria-label="text formatting" className={classes.togglebtngroup} exclusive>
          {
            groups.map(group => {
              return (
                <ToggleButton key={group} value={group} aria-label={group}
                  classes={{
                    root: classes.togglebtn,
                    selected: classes.selectedBtn,
                    label: classes.btnLabel
                  }}>
                  {group == 'all' ? formatMessage({ id: "profile.service.all" }) : group}
                </ToggleButton>
              )
            })
          }
        </ToggleButtonGroup>
      }
      {
        enabled_apaves && enabled_apaves.length > 0 &&
        <>
          <Header title={formatMessage({ id: "applications.ownservice" })} />
          <ApplicationContent
            data={enabled_apaves}
            active={true}
            onBookMark={onBookMark}
            bookmarks={bookmarks} />
          <br />
          <Divider />
        </>
      }
      {
        !hideBookmark && bookmarked_apaves && bookmarked_apaves.length > 0 &&
        <>
          <Header title={formatMessage({ id: "applications.likedservice" })} />
          <ApplicationContent
            data={bookmarked_apaves}
            onBookMark={onBookMark}
            bookmarks={bookmarks} />
          <br />
          <Divider />
        </>
      }
      {
        disabled_apaves && disabled_apaves.length > 0 &&
        <>
          <Header title={formatMessage({ id: "applications.apaveservice" })} />
          <div className={classes.mainContent}>
            <ApplicationContent
              animation='slide'
              data={disabled_apaves}
              onBookMark={onBookMark}
              bookmarks={bookmarks}
            />
          </div>
        </>
      }
    </div>
  );
};
Applications.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }),
  disablePadding: PropTypes.bool,
  hideBookmark: PropTypes.bool,
  title: PropTypes.string,
  hideSubtitle: PropTypes.bool,
  searchPlaceholder: PropTypes.string
};
export default injectIntl(Applications);
